export const appConfig = {
  serviceUrl: process.env.REACT_APP_PLATFORM_API_URL || 'http://localhost:3000',
  linkedinClientId: process.env.LINKEDIN_CLIENT_ID,
  linkedinCallbackUrl: process.env.LINKEDIN_CALLBACK_URL,
};
